import iFrameResize from 'iframe-resizer/js/iframeResizer'

export default {
    install: function(Vue) {
        Vue.directive('resize', {
            inserted: function (el) {
                iFrameResize({log: false}, '#' + el.id);
            }
        });
    }
}